import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./listings_date_picker.css";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
